import { render } from "./HelpInfoButtonIcon.vue?vue&type=template&id=6e4dd788"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__